// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__2wXx8","dense":"_type_dense__1UApX"};